import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { WindowService } from '@shared/window';
import { RouterLink } from '@angular/router';
import { ButtonComponent } from '../../shared/components/button/button.component';
import { LocalizePipe } from '../../i18n/pipes/lozalize.pipe';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-cookie-bar',
    templateUrl: './cookie-bar.component.html',
    styleUrls: ['./cookie-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink, ButtonComponent, LocalizePipe, TranslatePipe],
})
export class CookieBarComponent implements OnInit {
    private cookieService = inject(CookieService);
    private windowService = inject(WindowService);

    cookieExists: boolean = this.cookieService.check('show-cookies-info');
    showCookieBar?: boolean;
    isBrowserEnableCookies?: boolean;

    ngOnInit(): void {
        if (this.windowService.isBrowser) {
            if (this.cookieExists) {
                this.showCookieBar = false;
            } else {
                this.showCookieBar = true;
            }
            this.isBrowserEnableCookies = navigator.cookieEnabled;
        }
    }

    hideCookieBar(): void {
        if (this.isBrowserEnableCookies) {
            this.cookieService.set('show-cookies-info', 'no');
        }
        this.showCookieBar = false;
    }
}
